import React, { useState, useEffect } from 'react';
import './StatusPage.css';

export default function StatusPage() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    // Static data; replace with real API call if available
    const data = [
      { name: 'API', status: 'Operational', uptime: '100%', responseTime: '22ms' },
      { name: 'Web Portal', status: 'Operational', uptime: '100%', responseTime: '45ms' },
      { name: 'SMS Gateway', status: 'Operational', uptime: '99.99%', responseTime: '50ms' },
      // { name: 'Email Service', status: 'Operational', uptime: '99.99%', responseTime: '80ms' },
      { name: 'IVR / Telephony', status: 'Operational', uptime: '100%', responseTime: '9ms' },
      { name: 'AI Engine', status: 'Operational', uptime: '100%', responseTime: '14ms' },
      // { name: 'Database', status: 'Operational', uptime: '99.99%', responseTime: '100ms' },
      { name: 'Analytics', status: 'Operational', uptime: '100%', responseTime: '220ms' },
    ];
    setServices(data);
  }, []);

  return (
    <div className="status-page">
      <header className="status-hero">
        <h1>System Status</h1>
        <p>Live status of all VoicePro services.</p>
      </header>
      <div className="last-updated">Last updated: {new Date().toLocaleString()}</div>
      <table className="status-table">
        <thead>
          <tr><th>Service</th><th>Status</th><th>Uptime(Past 7 Days)</th><th>Avg Response Time</th></tr>
        </thead>
        <tbody>
          {services.map(s => (
            <tr key={s.name}>
              <td>{s.name}</td>
              <td className={`status-${s.status.toLowerCase().replace(/\s+/g, '-')}`}>{s.status}</td>
              <td>{s.uptime}</td>
              <td>{s.responseTime}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <section className="incident-history">
        <h2>Recent Incidents</h2>
        <ul>
          <li><strong>2025-04-21 13:00 UTC:</strong> SMS Gateway experienced partial delay sending messages (resolved)</li>
          <li><strong>2025-04-10 02:00 UTC:</strong> Scheduled maintenance on IVR system</li>
          <li><strong>2025-03-30 23:45 UTC:</strong> Brief API latency spike (0.5 hour)</li>
        </ul>
      </section>
    </div>
  );
}
